import Plus from '@assets/icons/plus';
import {
  CONTACT_SUPPORT_URL,
  PAGE_WEBINAR_SELECT,
} from '@utils/constants/mock-exam.constants';
import React from 'react';

const WebinarThankYouPage = ({
  parentName,
  orderNumber,
  parentEmail,
  setStep,
}: {
  parentName: string;
  orderNumber: string;
  parentEmail: string;
  setStep: React.Dispatch<React.SetStateAction<string>>;
}) => {
  return (
    <>
      <p className="text-[24px] leading-[35px] text-primary-navyblue font-black mb-4 break-words">
        Thank you for registering, {parentName}!
      </p>
      <p className="text-neutral-pencil mb-8 break-words">
        Your purchase is successful with the order number{' '}
        <strong>{orderNumber}</strong>
        <br />
        <br />
        We emailed your order confirmation and further instructions to{' '}
        <u>{parentEmail}</u>
        <br />
        <br />
        Please note: the email may take a few minutes to arrive. Please check
        your spam mailboxes. Need help?{' '}
        <a
          href={CONTACT_SUPPORT_URL}
          target="_blank"
          className="text-primary-apricot underline font-medium"
          rel="noreferrer"
        >
          Contact our support team
        </a>
      </p>
      <div
        className="text-primary-apricot font-bold flex align-bottom hover:cursor-pointer"
        onClick={() => setStep(PAGE_WEBINAR_SELECT)}
      >
        <div className="pt-[6px]">
          <Plus className="h-4 w-[14px]" />
        </div>
        <div className="underline ml-1">Register for more webinars</div>
      </div>
    </>
  );
};

export default WebinarThankYouPage;
